export default __webpack_public_path__ + "static/media/devguide09.829c0a76.md";